window.addEventListener("trix-file-accept", function(event) {
    const acceptedTypes = ['image/jpeg', 'image/png', 'text/csv', 'image/jpeg', 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    if (!acceptedTypes.includes(event.file.type)) {
        event.preventDefault()
        alert("Solo se adminten extenciones: JPEG, PNG, PDF, XLS y XLSX")
    }
});